import { FundingCampaign } from "./FundingCampaign";
import { DataModelV2 } from "./data";
import "react-multi-carousel/lib/styles.css";
import { AutoStoppingCarousel } from "./support/AutoStoppingCarousel";
import { useInstance } from "@meraki-internal/react-dependency-injection";

const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 5
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 3
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1
    }
};
export const OtherFundingCampaigns: React.FC = () => {
    const data = useInstance(DataModelV2);

    return (
        <section className="section-content-block">

            <div className="container">

                <div className="row section-heading-wrapper">

                    <div className="col-md-12 col-sm-12 text-center">
                        <h2>Our Fundraising <span>Goals and Initiatives</span></h2>
                        <h4>Fund new and existing teams for seasons to come!</h4>
                    </div>

                </div>
                <div className="row wow fadeIn">
                    <div className="cause-container" id="campaign-list">
                        <AutoStoppingCarousel responsive={responsive}
                            autoPlaySpeed={4000}
                        >
                            {data.getShuffledOtherCampaigns().map(campaign => (
                                <FundingCampaign key={campaign.url} campaign={campaign} />
                            ))}
                        </AutoStoppingCarousel>
                    </div>
                </div>
            </div>
        </section>
    );
}